export const calculatePasswordScore = (password) => {
  if (!password || password.trim() === "") return 0; // Blank
  if (password.length < 1) return 0; // Blank
  if (password.length < 4) return 1; // VeryWeak

  let score = 0;

  if (password.length >= 8) score += 1; // Uzunluk kontrolü
  if (/[0-9]/.test(password)) score += 1; // Rakam kontrolü
  if (/[a-z]/.test(password)) score += 1; // Küçük harf kontrolü
  if (/[A-Z]/.test(password)) score += 1; // Büyük harf kontrolü
  if (/[~!@#$%^&*()_+={}|[\]:;"'<,>.?]/.test(password)) score += 1; // Özel karakter kontrolü

  return score;
};

export const PasswordScore = {
  Blank: 0,
  VeryWeak: 1,
  Weak: 2,
  Medium: 3,
  Strong: 4,
  VeryStrong: 5
};

// Türkçe karşılıkları
export const PasswordScoreLabels = [
  "",
  "Şifreniz Zayıf",
  "Şifreniz Zayıf",
  "Şifreniz Zayıf",
  "Şifreniz Zayıf",
  "Şifreniz Güçlü"
];

export const PasswordScoreClasses = [
  "text-gray-400", // Blank
  "text-red-500", // VeryWeak
  "text-red-500", // Weak
  "text-red-500", // Medium
  "text-red-500", // Strong
  "text-green-800" // VeryStrong
];
